
import Vue from "vue"
import type { FullSession } from "@/types/api/program"

export default Vue.extend({
  layout: "index",

  // validate ({ store }) { return store.getters["user/isAdmin"] },

  async asyncData ({ route, $api, error }) {
    const [res, err] = await $api.program.getSession(route.params.sessionAlias)
    if (err) error({ statusCode: 404, message: err.message || err })
    else return { session: res }
  },

  data: () => ({
    session: null as FullSession | null,
  }),
})
